import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/sections.css";
import { ArrowRight } from "../components/Icons";

const SIZES = [
  {
    name: "Whole",
    fraction: "1/1",
    suits: "Large families, batch cooks and anyone stocking a chest freezer for the year.",
    freezer: "Full chest freezer",
  },
  {
    name: "Half",
    fraction: "1/2",
    suits: "A family of four to six who cook most meals at home.",
    freezer: "Large freezer drawer",
  },
  {
    name: "Quarter",
    fraction: "1/4",
    suits: "The most popular share — a household of three or four eating meat a few times a week.",
    freezer: "Standard freezer",
    featured: true,
  },
  {
    name: "Eighth",
    fraction: "1/8",
    suits: "Couples and small households who want variety without the commitment.",
    freezer: "Freezer shelf",
  },
  {
    name: "Sixteenth",
    fraction: "1/16",
    suits: "A first taste. Ideal if you are new to community shares and want to try it out.",
    freezer: "A few shelves",
  },
];

const ShareSizes = () => (
  <section id="shares" className="section section--alt share-sizes">
    <div className="container">
      <div className="section-head" data-reveal>
        <span className="eyebrow">Share sizes</span>
        <h2>Find the share that fits your freezer</h2>
        <p>
          A community share splits one animal fairly between neighbours. Pick the portion that
          matches how your household eats — pricing scales directly with the size you choose.
        </p>
      </div>

      <div className="size-grid">
        {SIZES.map((size, index) => (
          <article
            className={`size-card ${size.featured ? "is-featured" : ""}`}
            key={size.name}
            data-reveal
            style={{ "--reveal-delay": `${index * 70}ms` }}
          >
            {size.featured && <span className="size-flag">Most popular</span>}
            <span className="size-fraction" aria-hidden="true">
              {size.fraction}
            </span>
            <h3>{size.name} share</h3>
            <p>{size.suits}</p>
            <span className="size-meta">{size.freezer}</span>
          </article>
        ))}
      </div>

      <div className="size-footnote" data-reveal>
        <p>
          Not sure which to pick? Every campaign lists the exact price for each size before you
          check out.
        </p>
        <Link to="/order-now" className="btn">
          See current pricing
          <ArrowRight />
        </Link>
      </div>
    </div>
  </section>
);

export default ShareSizes;
